
import { useState } from 'react';
import { Product } from '@/lib/supabase/products';

export const useSelectedProducts = () => {
  const [selectedProducts, setSelectedProducts] = useState<string[]>([]);

  const toggleProductSelection = (id: string) => {
    setSelectedProducts(prev => 
      prev.includes(id) 
        ? prev.filter(productId => productId !== id) 
        : [...prev, id]
    );
  };

  // Updated to accept either products array or empty array to clear selections
  const toggleSelectAll = (products: Product[]) => {
    if (products.length === 0) {
      // Clear all selections if empty array is passed
      setSelectedProducts([]);
    } else if (selectedProducts.length === products.length) {
      setSelectedProducts([]);
    } else {
      setSelectedProducts(products.map(product => product.id));
    }
  };

  const areAllSelected = (products: Product[]) => {
    return products.length > 0 && selectedProducts.length === products.length;
  };

  return {
    selectedProducts,
    toggleProductSelection,
    toggleSelectAll,
    areAllSelected
  };
};
